import {calculateViewportDimensions, startWhichSizeVideo, utils, vh} from './utils';
//import { gsap } from '../libs/gsap.min';
//import { ScrollTrigger } from '../libs/ScrollTrigger.min';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


ScrollTrigger.normalizeScroll(true); // enable


startWhichSizeVideo(document.body);


/**
 * Loading screen animation
 */
document.body.classList.add('loading');

/*const heroVideo = document.querySelector('.hero video');

heroVideo.addEventListener('loadeddata', function () {

});*/

window.addEventListener('load', function (event) {
	setTimeout(function () {
		hideLoadingScreen();
	}, 1000);
});

setTimeout(function () {
	hideLoadingScreen();
}, 10000);

function hideLoadingScreen() {
	const hero = document.querySelector('.hero');

	if (hero)
	{
		hero.classList.add('hidden');
	}

	document.body.classList.remove('loading');
	calculateViewportDimensions();
}


/**
 * Menu animation
 */
const menu = document.querySelector('.menu');

if (menu)
{
	function openMenu() {
		menu.classList.remove('menu--closed');
		menu.removeEventListener('click', openMenu);
	}

	function closeMenu() {
		menu.classList.add('menu--closed');

		setTimeout(function () {
			menu.addEventListener('click', openMenu);

		}, 300);
	}

// open menu when menu dot is clicked
	menu.addEventListener('click', openMenu);

// close menu when .menu_close is clicked
	document.querySelector('.menu__close').addEventListener('click', closeMenu);

// close menu when anchor is clicked
	menu.querySelectorAll('a').forEach((el) => {
		el.addEventListener('click', closeMenu);
	});

// close menu on scroll
	window.addEventListener('scroll', throttle(closeMenu, 100));

	function throttle(func, timeFrame) {
		let lastTime = 0;
		return function (...args) {
			let now = new Date();
			if (now - lastTime >= timeFrame)
			{
				func(...args);
				lastTime = now;
			}
		};
	}
}


/**
 * Perspective section animations
 */
VanillaTilt.init(document.querySelectorAll('.perspective__tilt'), {
	max:         15,
	speed:       600,
	perspective: 5000,
	glare:       false,
	//"max-glare":           0.75,
	reset:                 false,
	reverse:               false,
	"full-page-listening": true,
	gyroscope:             true
});

const textToSplit     = document.querySelector('.perspective__tilt p:first-child');

if (textToSplit)
{
	const text            = textToSplit.textContent;
	const textWrapped     = text.replace(/[\w?]/g, '<span>$&</span>');
	textToSplit.innerHTML = textWrapped;
}


/**
 * Projects section animation
 */
let projects = gsap.utils.toArray(".project");
let projectsTween;


let gsapMatchmedia = gsap.matchMedia();

gsapMatchmedia.add({
	isDesktop: '(min-width: 992px)',
	isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
	isMobile:  '(max-width: 767.98px)'

}, (context) => {

	let {isMobile} = context.conditions;

	projectsTween = gsap.to(projects, {
		xPercent:      -100 * (projects.length - 1),
		ease:          "none",
		scrollTrigger: {
			trigger: '.project-section',
			pin:     true,
			scrub:   1,
			start:   () => 'top top',
			end:     () => isMobile ? '+=' + vh(300) : '+=' + vh(1000),
			//markers: true
		}
	});
});



// this scrolling object just allows us to conveniently call scrolling.enable(), scrolling.disable(), and check if scrolling.enabled is true.
// some browsers (like iOS Safari) handle scrolling on a separate thread and can cause things to get out of sync (jitter/jumpy), so when we're animating the scroll position, force an update of GSAP tweens when there's a scroll event in order to maintain synchronization
export const scrolling = {
	enabled: true,
	events:  "scroll,wheel,touchmove,pointermove".split(","),
	prevent: e => e.preventDefault(),
	disable() {
		if (scrolling.enabled)
		{
			scrolling.enabled = false;
			window.addEventListener("scroll", gsap.ticker.tick, {passive: true});
			scrolling.events.forEach((e, i) => (i ? document : window).addEventListener(e, scrolling.prevent, {passive: false}));
		}
	},
	enable() {
		if (!scrolling.enabled)
		{
			scrolling.enabled = true;
			window.removeEventListener("scroll", gsap.ticker.tick);
			scrolling.events.forEach((e, i) => (i ? document : window).removeEventListener(e, scrolling.prevent));
		}
	}
};


/*function goToSection(project, i) {
	if (scrolling.enabled) // skip if a scroll tween is in progress
	{
		scrolling.disable();
		gsap.to(window, {
			scrollTo:   {y: project, autoKill: false},
			onComplete: scrolling.enable,
			duration:   1.5,
			ease:       "power3.inOut"
		});
	}
}*/

//let projectSectionsMediaQuery = gsap.matchMedia();

/*projectSectionsMediaQuery.add("(pointer: fine)", () => {

	const projectSections = document.querySelectorAll('.project-section');

	projectSections.forEach((projectSection, i) => {

		const projects = projectSection.querySelectorAll('.project');

		projects.forEach((project, i) => {

			ScrollTrigger.create({
				trigger:     project,
				start:       "top bottom-=1",
				end:         "bottom top+=1",
				onEnter:     (self) => {
					goToSection(project);

					project.classList.add('active');

					let prevProject = utils.prev(project);

					if (prevProject !== null)
					{
						prevProject.classList.add('out');
						prevProject.classList.remove('active');
					}

				},
				onEnterBack: (self) => {
					goToSection(project);

					project.classList.remove('out');
					project.classList.add('active');

					let nextProject = utils.next(project);

					if (nextProject !== null)
					{
						nextProject.classList.remove('active');
					}
				},
				//markers:     true
			});

			const firstProject = projects.item(0);
			const lastProject  = projects.item(projects.length - 1);

			if (project === firstProject)
			{
				ScrollTrigger.create({
					trigger:     project,
					start:       "bottom bottom+=1",
					end:         "+10",
					onEnterBack: (self) => {
						goToSection(utils.prev(project.parentNode));

						project.classList.remove('out');
						project.classList.remove('active');
					},
					//markers:     true
				});
			}

			if (project === lastProject)
			{
				ScrollTrigger.create({
					trigger: project,
					start:   "top top-=1",
					onEnter: (self) => {
						goToSection(utils.next(project.parentNode));

						project.classList.add('out');
						project.classList.remove('active');
					},
					//markers:     true
				});
			}
		});
	});

});*/

/**
 * About us section animation
 */
const aboutUsSection = document.querySelector('.about-us');

if (aboutUsSection)
{
	const aboutUsSectionVideo = aboutUsSection.querySelector('video');

	gsapMatchmedia.add({
		isDesktop: '(min-width: 992px)',
		isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
		isMobile:  '(max-width: 767.98px)'

	}, (context) => {

		let {isMobile} = context.conditions;

		ScrollTrigger.create({
			trigger:  aboutUsSection,
			start:    "top top",
			end:     () => isMobile ? '+=' + vh(100) : '+=' + vh(200),
			pin:      true,
			onUpdate: (self) => {
				let progress = self.progress.toFixed(2) * 100;

				if (progress > 50)
				{
					self.trigger.classList.add('half');
				}
				else
				{
					self.trigger.classList.remove('half');
				}
			},
			//markers:     true
		});

		ScrollTrigger.create({
			trigger:  aboutUsSection,
			start:    "top bottom",
			end:     () => isMobile ? '+=' + vh(300) : '+=' + vh(400),
			onEnter:     () => {
				try
				{
					aboutUsSectionVideo.play().then(() => {}).catch(() => {});
				}catch(e){}
			},
			onEnterBack: () => {
				try
				{
					aboutUsSectionVideo.play().then(() => {}).catch(() => {});
				}catch(e){}
			},
			onLeave:     () => {aboutUsSectionVideo.pause()},
			onLeaveBack: () => aboutUsSectionVideo.pause(),
			//markers:     true
		});
	});
}


/**
 * Services section animation
 */
ScrollTrigger.create({
	trigger:     '.services',
	start:       "top 50%",
	end:         "bottom 50%",
	toggleClass: 'trigger-1',
	//markers:     true
});

ScrollTrigger.create({
	trigger:     '.services',
	start:       "top top",
	end:         "bottom top",
	toggleClass: 'trigger-2',
	//markers:     true
});


/**
 * Clients section animation
 */
ScrollTrigger.create({
	trigger:     '.clients',
	start:       "top 50%",
	end:         "bottom 50%",
	toggleClass: 'trigger-1',
	//markers:     true
});



/**
 * Force ALL ScrollTrigger instances to re-calculate its start and end values after each image is loaded
 */
/*let images = document.querySelectorAll('img');

Promise.all(Array.from(images).map(img => {

	if (img.complete)
	{
		return Promise.resolve(img.naturalHeight !== 0);
	}

	return new Promise(resolve => {

		img.addEventListener('load', () => {

			// refresh here
			ScrollTrigger.refresh();

			resolve(true);
		});

		img.addEventListener('error', () => resolve(false));

	});

})).then(results => {

	if (results.every(res => res))
	{
		//console.log('all images loaded successfully');
	}
	else
	{
		//console.log('some images failed to load, all finished loading');
	}

});*/


const tippyTemplate = document.querySelector('.header__teaser-template');

if (tippyTemplate)
{
	tippy('.header__teaser', {
		content: tippyTemplate.innerHTML,
		allowHTML: true,
	});
}


const tippyTemplateLowPower = document.querySelector('.header__teaser-template-lowpower');

if (tippyTemplateLowPower)
{
	tippy('.header__teaser-lowpower', {
		content: tippyTemplateLowPower.innerHTML,
		allowHTML: true,
	});
}


function checkLowPowerMode(err) {
	if (err.name === "NotAllowedError" && !document.body.classList.contains('low-power-mode'))
	{
		document.body.classList.add('low-power-mode');
	}
}

try{
	let video = document.querySelector('.hero video');
	video.play().then(() => {}).catch(checkLowPowerMode);
}catch(e){}





/**
 * Autoplay video when it's in view
 */
const videoBackgroundSections = gsap.utils.toArray('.video-background')

videoBackgroundSections.forEach(function (section, i) {

	let video = section.querySelector('video');

	ScrollTrigger.create({
		trigger: section,
		start:   'top bottom',
		end:     'bottom top',
		//markers:     true,
		onEnter:     () => {
			try
			{
				video.play().then(() => {}).catch(() => {});
			}catch(e){}
		},
		onEnterBack: () => {
			try
			{
				video.play().then(() => {}).catch(() => {});
			}catch(e){}
		},
		onLeave:     () => video.pause(),
		onLeaveBack: () => video.pause(),
	});

});


const projectsSections      = gsap.utils.toArray('.project')
const projectSectionsNumber = projectsSections.length;

gsapMatchmedia.add({
	isDesktop: '(min-width: 992px)',
	isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
	isMobile:  '(max-width: 767.98px)'

}, (context) => {

	let {isMobile} = context.conditions;

	projectsSections.forEach(function (section, i) {

		let video = section.querySelector('video');

		// play/pause first video
		ScrollTrigger.create({
			trigger:     '.project-section',
			start:       'top bottom',
			end:         () => isMobile ? '+=' + vh(400) : '+=' + vh(1100),
			//markers:     {startColor: 'blue', endColor: 'blue', indent: 100},
			onEnter:     () => {
				if (i === 0)
				{
					try
					{
						video.play().then(() => {}).catch(() => {});
					}catch(e){}
				}
			},
			onLeaveBack: () => {
				video.pause();
			},
		});

		// play/pause last video
		ScrollTrigger.create({
			trigger:     '.project-section',
			start:       'top top',
			end:         () => isMobile ? '+=' + vh(400) : '+=' + vh(1100),
			//markers:     {startColor: 'yellow', endColor: 'yellow', indent: 200},
			onLeave:     () => {
				if (i === projectSectionsNumber - 1)
				{
					video.pause();
				}
			},
			onEnterBack: () => {
				if (i === projectSectionsNumber - 1)
				{
					try
					{
						video.play().then(() => {}).catch(() => {});
					}catch(e){}
				}
			}
		});

		// play/pause all videos
		ScrollTrigger.create({
			containerAnimation: projectsTween,
			trigger:            section,
			start:              'top bottom',
			end:                'bottom top',
			//markers:            true,
			onEnter:            () => {
				try
				{
					video.play().then(() => {}).catch(() => {});
				}catch(e){}
			},
			onEnterBack:        () => {
				try
				{
					video.play().then(() => {}).catch(() => {});
				}catch(e){}
			},
			onLeave:            () => video.pause(),
			onLeaveBack:        () => video.pause(),
		});
	});
});


let stopPropagation = e => e.stopImmediatePropagation();
document.querySelectorAll('.popup__body').forEach(el => {
	if (el.scrollHeight > el.clientHeight) {
		el.addEventListener("wheel", stopPropagation);
		el.addEventListener("touchstart", stopPropagation);
	}
});


const formSubmitBtn = document.getElementById('gform_submit_button_1');

if (formSubmitBtn)
{
	formSubmitBtn.classList.add('btn', 'btn--outline-white');
}


gsap.from(".hand", {
	opacity:  0,
	y:        200,
	duration: 2
});


gsap.from(".btn", {
	opacity:  0,
	y:        50,
	duration: 2
});



/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {


});



/**
 * ON RESIZE
 */

window.addEventListener('resize', function (event) {
	if (event.target === window)
	{
		// trigger resizeEnd event only when the window resizing ends
		if (this.resizeTO)
		{
			clearTimeout(this.resizeTO);
		}
		this.resizeTO = setTimeout(function () {
			const event = new CustomEvent('resizeEnd');
			window.dispatchEvent(event);
		}, 200);
	}
});



/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});



/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/